module.exports = __webpack_public_path__ + "percent-coin.06e0a191.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallet/percent-coin.png
// module id = 2479
// module chunks = 0